import type { JSResourceOptions, Loader, PreloadableJSResourceReference } from '../../types';
import { createCache } from '../../utils';
import { PreloadableJSResource } from '../preloadable-js-resource';
import { postTask } from '../scheduler';

const cache = createCache(new Map<string, PreloadableJSResourceReference<any>>());

/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */
const RUNTIME_STRING_ERROR =
	'JSResourceForBackground was called with a string path at runtime. ' +
	'Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.';

export function JSResourceForBackground<T = unknown>(
	path: string,
	opts?: JSResourceOptions,
): PreloadableJSResourceReference<T>;

export function JSResourceForBackground<T = unknown>(
	loader: Loader<T>,
	opts?: JSResourceOptions,
): PreloadableJSResourceReference<T>;

export function JSResourceForBackground<T = unknown>(
	loaderOrPath: Loader<T> | string,
	opts?: JSResourceOptions,
): PreloadableJSResourceReference<T> {
	if (typeof loaderOrPath === 'string') {
		throw new Error(`${RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
	}
	return cache.get(opts!.moduleId!, () =>
		PreloadableJSResource(() => postTask(loaderOrPath, { priority: 'background' }), opts!),
	);
}
